import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { externalActions, TwilioChannelType } from "../ducks/external";
import { useAsset } from "./useAsset";

export const useTwilio = () => {
  const dispatch = useDispatch();
  const { showSms } = useAsset();

  const checkTwilioCode = useCallback(
    (
      code: string,
      channel: TwilioChannelType,
      value: string,
      onSuccess: () => void,
      onError: () => void,
    ) => {
      if (!showSms) return onSuccess();

      if (channel === TwilioChannelType.Sms && value.startsWith("0")) {
        value = "+81" + value.slice(1);
      }

      dispatch(
        externalActions.checkTwilioCode.started({
          Code: code,
          To: value,
          onSuccess,
          onError,
        }),
      );
    },
    [showSms],
  );

  const sendTwilioCode = useCallback(
    (
      channel: TwilioChannelType,
      value: string,
      onSuccess: () => void,
      onError: () => void,
    ) => {
      if (!showSms) return onSuccess();

      if (channel === TwilioChannelType.Sms && value.startsWith("0")) {
        value = "+81" + value.slice(1);
      }

      dispatch(
        externalActions.sendTwilioCode.started({
          To: value,
          Channel: channel.valueOf(),
          onSuccess,
          onError,
        }),
      );
    },
    [showSms],
  );

  return { checkTwilioCode, sendTwilioCode };
};
